import { render, staticRenderFns } from "./Xzkc.vue?vue&type=template&id=74952661&scoped=true"
import script from "./Xzkc.vue?vue&type=script&lang=js"
export * from "./Xzkc.vue?vue&type=script&lang=js"
import style0 from "./Xzkc.vue?vue&type=style&index=0&id=74952661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74952661",
  null
  
)

export default component.exports